export default "__VITE_ASSET__6AFdxos5__"